import { render, staticRenderFns } from "./PhoneCall.vue?vue&type=template&id=56fbbed6&"
import script from "./PhoneCall.vue?vue&type=script&lang=ts&"
export * from "./PhoneCall.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports